import { render, staticRenderFns } from "./LegalCaseFiles.vue?vue&type=template&id=25385a51"
import script from "./LegalCaseFiles.vue?vue&type=script&lang=js"
export * from "./LegalCaseFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports